/**
 * @author       tae@zumper.com (Tae Yoon)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  Messaging Modal meta reducer
 */

import { falseReducer, nullReducer, payloadReducer, trueReducer } from '@zcode/reducers'
import type { MessageModal } from '@zcode/state-type'
import { combineReducers } from 'redux'
import { handleActions } from 'redux-actions'
import {
  CANCEL_FETCHING_ENTITY,
  DONE_FETCHING_ENTITY,
  ERROR_FETCHING_ENTITY,
  START_FETCHING_ENTITY,
} from '../../constants/messageModal'
import type { ActionTypes } from '../../types'

export const metaReducer = combineReducers<MessageModal['meta'], ActionTypes>({
  canceled: handleActions(
    {
      [CANCEL_FETCHING_ENTITY]: trueReducer,
      [DONE_FETCHING_ENTITY]: falseReducer,
      [START_FETCHING_ENTITY]: falseReducer,
    },
    false
  ),
  error: handleActions<MessageModal['meta']['error'], ActionTypes>(
    {
      [ERROR_FETCHING_ENTITY]: payloadReducer,
      [START_FETCHING_ENTITY]: nullReducer,
    },
    null
  ),
  fetching: handleActions(
    {
      [START_FETCHING_ENTITY]: trueReducer,
      [DONE_FETCHING_ENTITY]: falseReducer,
    },
    false
  ),
  fetchingKey: handleActions<MessageModal['meta']['fetchingKey'], ActionTypes>(
    {
      [START_FETCHING_ENTITY]: payloadReducer,
      [CANCEL_FETCHING_ENTITY]: nullReducer,
      [DONE_FETCHING_ENTITY]: nullReducer,
    },
    null
  ),
})
